import React from "react";

export default function EmpAttendance() {
  const attendanceData = [
    {
      date: "12 Jan 2025",
      day: "Monday",
      inTime: "09:05 AM",
      outTime: "06:10 PM",
      totalHours: "8h 5m",
      status: "Present",
      remarks: "On time",
    },
    {
      date: "11 Jan 2025",
      day: "Sunday",
      inTime: "-",
      outTime: "-",
      totalHours: "-",
      status: "Absent",
      remarks: "No Leave",
    },
    {
      date: "10 Jan 2025",
      day: "Friday",
      inTime: "09:30 AM",
      outTime: "06:00 PM",
      totalHours: "7h 30m",
      status: "Late",
      remarks: "Late by 30 mins",
    },
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case "Present":
        return "bg-green-500 text-white";
      case "Absent":
        return "bg-red-500 text-white";
      case "Late":
        return "bg-yellow-400 text-gray-800";
      case "Half-Day":
        return "bg-orange-400 text-white";
      default:
        return "bg-gray-200 text-gray-800";
    }
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h2 className="text-3xl font-bold mb-6 text-gray-800">Attendance</h2>

      <div className="bg-white shadow-lg rounded-2xl overflow-x-auto">
        <table className="w-full min-w-[700px]">
          <thead className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white">
            <tr>
              <th className="p-3 text-left">Date</th>
              <th className="p-3 text-left">Day</th>
              <th className="p-3 text-left">In Time</th>
              <th className="p-3 text-left">Out Time</th>
              <th className="p-3 text-left">Total Hours</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-left">Remarks</th>
            </tr>
          </thead>
          <tbody>
            {attendanceData.map((att, idx) => (
              <tr
                key={idx}
                className="border-b hover:bg-gray-50 transition-colors"
              >
                <td className="p-3">{att.date}</td>
                <td className="p-3">{att.day}</td>
                <td className="p-3">{att.inTime}</td>
                <td className="p-3">{att.outTime}</td>
                <td className="p-3">{att.totalHours}</td>
                <td className="p-3">
                  <span
                    className={`px-3 py-1 rounded-full text-sm font-semibold ${getStatusColor(
                      att.status
                    )}`}
                  >
                    {att.status}
                  </span>
                </td>
                <td className="p-3">{att.remarks}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
